var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.totalCount > 0)?_c(_setup.ActivityItem,{attrs:{"id":_vm.id,"activity-bar-id":_vm.id,"icon":_vm.icon,"indicator":_setup.totalCount,"is-active":_vm.isActive,"title":_vm.title,"tooltip":_setup.tooltip,"to":_vm.to},on:{"click":function($event){return _setup.emit('click')}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }